import { AnimatePresence } from "motion/react";
import { createContext, useContext, useRef } from "react";
import * as motion from "motion/react-client";
import useScreenDimensions from "../hooks/useScreenDimensions";
import { useQRModal } from "../hooks/useQRCodeModal";
import { QRCodeSVG } from "qrcode.react";
import { isMobile } from "react-device-detect";
import { toPng } from "html-to-image";
import downloadIcon from "../resources/whiteDownload.svg";
import useCampaigns from "../hooks/useCampaigns";


export const QRCodeModal = () => {
  const isOpen = useQRModal((state) => state.isOpen);
  const setIsOpen = useQRModal((state) => state.setIsOpen);
  const code = useQRModal((state) => state.code);
  const { width, height } = useScreenDimensions();
  const activeCampaign = useCampaigns(state => state.selectedCampaign);

  const cancelEvent = (e: React.MouseEvent) => e.stopPropagation();

  const closeModal = () => {
    setIsOpen(false);
  };
  const qrRef = useRef(null);

  // 2. Handler to download as PNG
  const handleDownloadPng = () => {
    if (!qrRef.current) return;

    toPng(qrRef.current, { cacheBust: true }) // optional: { width, height, backgroundColor } etc.
      .then((dataUrl) => {
        // 3. Create a download link and trigger a click
        const link = document.createElement("a");
        link.download = `${activeCampaign?.name.replaceAll(' ', '-')}-qr-code.png`; // suggested filename
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.error("Failed to convert to PNG:", err);
      });
  };

  return (
    <AnimatePresence>
      {isOpen ? (
        <motion.div
          key={"campaignModal"}
          style={{
            width,
            height,
            backgroundColor: "rgba(0, 0, 0, .3)",
            position: "fixed",
            zIndex: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            top: 0,
            left: 0,
          }}
          onClick={closeModal}
          animate={{ opacity: 1 }}
          initial={{ opacity: 0 }}
          exit={{ opacity: 0 }}
        >
          <div
            onClick={cancelEvent}
            style={{
              width: isMobile ? "90vw" : 450,
              minWidth: isMobile ? "90vw" : 400,
              backgroundColor: "white",
              padding: 24,
              borderRadius: 16,
              opacity: 1,
              position: 'relative'
            }}
          >
            <QRCodeSVG
              value={code}
              size={Math.min(400, 0.75 * width)}
              ref={qrRef}
            />
            <motion.div
              onClick={handleDownloadPng}
              whileHover={{ opacity: .5 }}
              style={{
                top: 0,
                left: 0,
                position: 'absolute',
                opacity: 0,
                width: '100%',
                height: '100%',
                backgroundColor: "black",
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            ><img style={{width: '20%', height: '20%'}} src={downloadIcon} /></motion.div>
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};
